import React, { useState, useEffect } from "react";
import {
  Typography,
  Paper,
  Select,
  MenuItem,
  OutlinedInput,
  Divider,
  Chip,
  ListSubheader,
  InputAdornment,
  TextField,
  Autocomplete,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import "../../styles/partCreation.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { automationHttpRequest } from "../../api/httpRequests";
import { DeblurOutlined } from "@mui/icons-material";

const PartDescription = ({
  handleContinue,
  setSearchString,
  setPartDescriptionData,
  disableContinue,
  onUomValidationChange,
}) => {
  const [noun, setNoun] = useState();
  const [modifier, setModifier] = useState();
  const [materialgroup, setMaterialgroup] = useState();
  const [nouns, setNouns] = useState([]);
  const [modifiers, setModifiers] = useState([]);
  const [materialgroups, setMaterialgroups] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [attributesObj, setAttributesObj] = useState({});
  const [attributeValues, setAttributeValues] = useState({});
  const [uomValues, setUOMValues] = useState({});
  const [attributeValue, setAttributeValue] = useState({});
  const [chipValues, setChipValues] = useState([]);
  const [initialChipValues, setInitialChipValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [uomValue, setUomValue] = useState({});
  const [updateAttributeValues, setUpdatedAttributeValues] = useState({});
  const [typeAttributeValue, setTypeAttributeValue] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [modifierSearch, setModifierSearch] = useState("");
  const [optionToShow, setOptionToShow] = useState([]);
  const [topAttribute, setTopAttribute] = useState([]);
  const [registeredAttribute, setRegisteredAttribute] = useState({});
  const [attributeTypeValue, setAttributeTypeValue] = useState({});
  const [totalUomValues, setTotalUomValues] = useState(0);

  useEffect(() => {
    if (uomValue && Object.keys(uomValue).length) {
      const mappedObject = Object.fromEntries(
        Object.entries(attributeValue)
          .filter(([key, value]) => {
            return !key.includes("UOM");
          })
          .map(([key, value]) => {
            if (Object.keys(uomValue).includes(key)) {
              const result = uomValue[key];
              return [key, `${value} ${result}`];
            } else {
              return [key, value];
            }
          })
      );
      setUpdatedAttributeValues(mappedObject);
    } else {
      setUpdatedAttributeValues(attributeValue);
    }
  }, [attributeValue, uomValue]);

  useEffect(() => {
    if (updateAttributeValues) {
      setPartDescriptionData((prevValue) => ({
        ...prevValue,
        attribute_data: updateAttributeValues,
      }));
    }
  }, [updateAttributeValues]);

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    width: "400px",
  };

  const headingStyle = {
    fontSize: 16,
    fontFamily: "Verdana",
    fontWeight: "700",
    margin: "30px 0px 10px 0px",
  };
  const headingStyleAttribute = {
    fontSize: 13,
    fontFamily: "Verdana",
    fontWeight: "600",
    margin: "30px 0px 10px 0px",
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };

  const uomProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 100,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };

  useEffect(() => {
    const isValid =
      Object.keys(attributeValue).length > 0 &&
      Object.keys(uomValue).length === totalUomValues;

    onUomValidationChange(isValid);
  }, [attributeValue, uomValue, totalUomValues]);

  useEffect(() => {
    fetchNouns();
  }, []);

  useEffect(() => {
    fetchMaterialGroup();
  }, []);

  useEffect(() => {
    const description = handlechipsValues(); // ✅ Use the function directly
    if (description) {
      setPartDescriptionData((prevValue) => ({
        ...prevValue,
        clean_short_description: description,
      }));
    }
  }, [chipValues, attributeValue, uomValue]);

  const fetchNouns = async () => {
    setFetching(true);
    try {
      const response = await automationHttpRequest.get("/get_noun/", {
        headers: {
          session_id: localStorage.getItem("session_id"),
          userEmail: localStorage.getItem("MRO_user_email"),
        },
      });
      if (response?.data?.status) {
        setNouns(response?.data?.data);
        setOptionToShow(response?.data?.data.slice(0, 100));
        setFetching(false);
      }
    } catch (error) {
      console.error("Error fetching nouns:", error);
    }
  };

  const fetchModifiers = async (selectedNoun) => {
    try {
      const response = await automationHttpRequest.post(
        "/get_modifier/",
        {},
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {
            noun: selectedNoun,
          },
        }
      );
      if (response?.data?.status) {
        setModifiers(response?.data?.data);
      }
    } catch (error) {
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };
  console.log(
    Object.keys(attributeValue),
    Object.keys(uomValue),
    totalUomValues
  );

  const fetchMaterialGroup = async () => {
    setFetching(true);
    try {
      const response = await automationHttpRequest.get("/get_materialgroup/", {
        headers: {
          session_id: localStorage.getItem("session_id"),
          userEmail: localStorage.getItem("MRO_user_email"),
        },
      });
      if (response?.data?.status) {
        setMaterialgroups(response?.data?.data);
        setOptionToShow(response?.data?.data.slice(0, 100));
        setFetching(false);
      }
    } catch (error) {
      console.error("Error fetching nouns:", error);
    }
  };

  const fetchAttributes = async (selected_modifier) => {
    setLoading(true);
    setAttributesObj({});
    setAttributeValue({});
    setAttributeTypeValue({});
    setUomValue({});
    try {
      const response = await automationHttpRequest.post(
        "/get_attribute/",
        {},
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {
            noun: noun,
            modifier: selected_modifier,
          },
        }
      );
      const attributeData = response.data.data;
      setTopAttribute(
        attributeData.map((item) => item.attribute_name).slice(0, 4)
      );
      setAttributes(attributeData.map((item) => item.attribute_name));

      //set attribute object
      setAttributesObj(
        attributeData.map((item) => ({
          attribute_name: item.attribute_name,
          group_order: item.group_order,
          attribute_order: item.attribute_order,
          noun_abbreviation: item.noun_abbreviation,
          modifier_abbreviation: item.modifier_abbreviation,
        }))
      );

      // Create an object to store attribute values
      const attributeValuesObject = {};
      attributeData.forEach((item) => {
        attributeValuesObject[item.attribute_name] =
          item.attribute_values || [];
      });
      setAttributeValues(attributeValuesObject);
      const uomValuesObject = {};
      attributeData.forEach((item) => {
        uomValuesObject[item.attribute_name] = item.uom || [];
      });
      const typeValuesObject = {};
      attributeData.forEach((item) => {
        typeValuesObject[item.attribute_name] = item.type || [];
      });
      setUOMValues(uomValuesObject);
      setTypeAttributeValue(typeValuesObject);
      setLoading(false);
    } catch (error) {
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const handleAttributeChange = (attribute, value, type) => {
    let tempValue = value ? ", " + value : "";
    if (type === "UOMChange") {
      const selectedAttr = attributesObj.find(
        (attr) => attr.attribute_name === attribute
      );
      if (!selectedAttr) return;

      const selectedOrder = selectedAttr.attribute_order;
      const newUom = value;

      const updatedUomValue = { ...uomValue };
      const updatedAttributeTypeValue = { ...attributeTypeValue };

      attributesObj.forEach((attr) => {
        const attrName = attr.attribute_name;
        const attrValue = attributeValue[attrName];

        if (
          attr.attribute_order === selectedOrder &&
          attrValue?.trim() // Only update if value is present
        ) {
          updatedUomValue[attrName] = newUom;
          updatedAttributeTypeValue[`${attrName}UOM`] = newUom;
        }
      });

      setUomValue(updatedUomValue);
      setAttributeTypeValue(updatedAttributeTypeValue);
    }

    let attributeKey = attribute.toString();
    const attributeIndex = attributes.indexOf(attributeKey);

    if (attributeIndex === -1) {
      // Attribute not found in the attributes array
      return;
    }

    attributeKey = type === "UOMChange" ? attributeKey + "UOM" : attributeKey;
    if (type === "nonSelect") {
      const isFractionInProgress =
        /^\s*(\d+\s+)?\d*\/?\d*\s*$/.test(value) && !/\s\/\s*\d*/.test(value);
      const isDecimalInProgress = /^\d+(\.\d*)?$/.test(value);

      const isValid = /^[0-9,/.\\-\s]*$/.test(value);

      // Reject if both '.' and '/' are present (mixed format)
      if (value.includes(".") && value.includes("/")) {
        return;
      }

      // Reject if not a valid in-progress decimal or fraction
      if (!isFractionInProgress && !isDecimalInProgress && value !== "") {
        return;
      }

      // Reject if user tries to mix formats (e.g., "1.5/2" or "1/2.5")
      if (value.includes("/") && isDecimalInProgress) {
        return; // Mixed format not allowed
      }

      if (!isValid) return 0;
      const numericValue = parseInt(value, 10);
      tempValue = numericValue ? ", " + value : "";
      if (isValid) {
        // Continue with your existing logic

        if (!isNaN(numericValue) && value !== "") {
          setAttributeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attribute]: value,
          }));
          if (
            numericValue.toString().length === 1 &&
            (attributeValue[attribute]?.toString()?.length === 0 ||
              !attributeValue[attribute])
          ) {
            setTotalUomValues(totalUomValues + 1);
          }
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attribute]: value,
          }));
        } else if (value === "" || value.length > 0) {
          delete attributeValue?.[attribute];
          delete attributeValue?.[attribute + "UOM"];
          setAttributeValue(attributeValue);
          if (value === "") {
            delete uomValue?.[attribute];
            delete attributeTypeValue?.[attribute + "UOM"];
            setUomValue(uomValue);
            setAttributeTypeValue(attributeTypeValue);
            setTotalUomValues(totalUomValues - 1);
          }
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attribute]: "",
          }));
        }
      }
      // else {
      //     setAttributeValue((prevAttributeValue) => ({
      //       ...prevAttributeValue,
      //       [attribute]: "",
      //     }))
      //     setAttributeTypeValue((prevAttributeValue) => ({
      //       ...prevAttributeValue,
      //       [attribute]: "",
      //     }));
      // }
    } else {
      if (value && type !== "nonSelect") {
        setAttributeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));
        setAttributeTypeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));
      } else {
        delete attributeValue?.[attributeKey];
        delete attributeTypeValue?.[attributeKey];
        setAttributeValue(attributeValue);
        setAttributeTypeValue(attributeTypeValue);
      }
    }
    // Update chipValues and registeredAttribute
    const updatedChipValues = [...chipValues];
    const updatedRegisteredAttribute = { ...registeredAttribute };
    if (updatedRegisteredAttribute.hasOwnProperty(attributeKey)) {
      // Update existing attributeKey
      updatedChipValues[
        updatedChipValues.indexOf(updatedRegisteredAttribute[attributeKey])
      ] = tempValue;
      if (
        updatedRegisteredAttribute.hasOwnProperty(attributeKey + "UOM") &&
        tempValue === ""
      ) {
        updatedRegisteredAttribute[attributeKey + "UOM"] = ",";
      }
      updatedRegisteredAttribute[attributeKey] = tempValue;
    } else {
      // Add new attributeKey
      updatedChipValues.push(tempValue);
      updatedRegisteredAttribute[attributeKey] = tempValue;
    }
    setRegisteredAttribute(updatedRegisteredAttribute);
    const output = attributes.flatMap((key) => [key, `${key}UOM`]);
    const sortedObject = Object.fromEntries(
      output.map((key) => [key, updatedRegisteredAttribute[key] || ""])
    );
    const outputString = Object.values(sortedObject)
      .filter((value) => value !== "")
      .join("");
    const chipContent = [...initialChipValues, outputString].join("");
    let totalChipsCharacters = chipContent.replace(/[\s,]/g, "");
    if (totalChipsCharacters.length < 40) {
      setChipValues(chipContent);
    }
  };

  const getSharedUomValue = (attributeName) => {
    const selectedAttr = attributesObj.find(
      (attr) => attr.attribute_name === attributeName
    );
    if (!selectedAttr) return "";

    const sameOrderAttrs = attributesObj.filter(
      (attr) => attr.attribute_order === selectedAttr.attribute_order
    );

    for (const attr of sameOrderAttrs) {
      if (uomValue[attr.attribute_name]) {
        return uomValue[attr.attribute_name];
      }
    }

    return "";
  };

  const handleUomChange = (attribute, value) => {
    const selectedAttribute = attributesObj.find(
      (attr) => attr.attribute_name === attribute
    );
    if (!selectedAttribute) return;

    const updatedUomValue = { ...uomValue }; // Find if any other attribute has the same attribute_order

    attributesObj.forEach((attr) => {
      if (
        attr.attribute_order === selectedAttribute.attribute_order &&
        attr.attribute_name !== attribute
      ) {
        // Remove the conflicting attribute
        delete updatedUomValue[attr.attribute_name];
      }
    }); // Set the new value

    updatedUomValue[attribute] = value;

    setUomValue(updatedUomValue);

    // setUomValue((prevAttributeValue) => ({
    //   ...prevAttributeValue,
    //   [attribute]: value,
    // }));
    // if (chipValues.length < 6) {
    //   setChipValues([...chipValues, value]);
    // }
  };

  const handleNounChange = (val) => {
    setInitialChipValues([val]);
    setChipValues([val]);
    setNoun(val);
    setTotalUomValues(0);
    setPartDescriptionData((prevValue) => ({
      ...prevValue,
      noun_indentifier: val,
    }));
    setRegisteredAttribute({});
    setModifiers([]);
    fetchModifiers(val);
    disableContinue();
  };

  const handleReset = () => {
    setNouns([]);
    setAttributeValue({});
    setModifiers([]);
    setMaterialgroups([]);
    setNoun();
    setModifier();
    setMaterialgroup();
    setTotalUomValues(0);
    setAttributes([]);
    setAttributeValues({});
    setChipValues([]);
    setInitialChipValues([]);
    fetchNouns();
    setRegisteredAttribute({});
    disableContinue();
  };

  const handleNext = () => {
    let shortData = handlechipsValues().split(",").slice(0, 3).join(",");
    setSearchString(shortData.replace(/:,/g, ":"));
    handleContinue();
  };

  const handleModifierChange = (val) => {
    setModifier(val);
    setTotalUomValues(0);
    // Retain only the first element in chipValues and append the new value
    setPartDescriptionData((prevValue) => ({
      ...prevValue,
      modifier: val,
    }));
    if (val != "ANY") {
      setInitialChipValues([noun, val] + ":");
      setChipValues([noun, val]);
    } else {
      setInitialChipValues([noun] + ":");
      setChipValues([noun]);
    }

    setRegisteredAttribute({});
    fetchAttributes(val);
  };

  const handlechipsValues = () => {
    // Group by Attribute_Order

    const attributeData = attributes
      .map((attrName, index) => {
        const matchedAttr = Array.isArray(attributesObj)
          ? attributesObj.find((item) => item.attribute_name === attrName)
          : null;
        return {
          name: attrName,
          value: attributeValue[attrName],
          unit: uomValue[attrName] || "",
          attributeOrder: matchedAttr?.attribute_order || index + 1, // Replace with actual order if available from backend
          groupOrder: matchedAttr?.group_order || index + 1, // Replace with actual group order if available
          noun_abbreviation: matchedAttr?.noun_abbreviation,
          modifier_abbreviation: matchedAttr?.modifier_abbreviation,
        };
      })
      .filter((attr) => attr.value); // ✅ Filter out empty values;
    const groupedByAttributeOrder = attributeData.reduce((acc, attr) => {
      const key = attr.attributeOrder;
      if (!acc[key]) acc[key] = [];
      acc[key].push(attr);
      return acc;
    }, {});

    const sortedOrders = Object.keys(groupedByAttributeOrder).sort(
      (a, b) => a - b
    );
    const attributeParts = sortedOrders
      .map((order) => {
        const group = groupedByAttributeOrder[order]; // Group by Group_Order

        const groupedByGroupOrder = group.reduce((acc, item) => {
          const key = item.attributeOrder;
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});

        const groupParts = Object.values(groupedByGroupOrder).map(
          (groupItems) => {
            if (groupItems.length === 1) {
              // Only one value in this group
              return `${groupItems[0].value}${groupItems[0].unit || ""}`;
            } else {
              // Multiple values in same groupOrder → combine with "*", append unit once
              const values = groupItems.map((i) => i.value).join("x");
              const unit = groupItems[0].unit || "";
              return `${values}${unit}`;
            }
          }
        );

        return groupParts.join("*");
      })
      .filter(Boolean); // ✅ Remove empty strings;
    const nounAbbreviation =
      attributeData.find((attr) => attr.noun_abbreviation)?.noun_abbreviation ||
      noun;
    const modifierAbbreviation =
      attributeData.find((attr) => attr.modifier_abbreviation)
        ?.modifier_abbreviation || modifier;

    let description = nounAbbreviation;
    if (modifierAbbreviation && modifierAbbreviation !== "ANY")
      description += `,${modifierAbbreviation}`;
    description += `:${attributeParts.join(",")}`;

    if (description.length > 39) {
      description = description.slice(0, 39) + ">";
    }

    return description;

    //let resultValue = "";

    // if (Array.isArray(values)) {
    //   resultValue = values.join(",");
    // } else if (typeof values === "string" || values instanceof String) {
    //   resultValue = values
    //     .split(",")
    //     .map((word) => word.trim())
    //     .filter((word) => word !== "")
    //     .join("," );
    // } else {
    //   resultValue = values;
    // }

    //let outputString = resultValue.replace(/:,(?=[^,])/g, ":");

    //return outputString;
  };

  // console.log(handlechipsValues("ABSORBENT:,AEROSOL,12ply"));
  const renderStyledAttribute = (attributeName) => {
    const selectedAttr = attributesObj.find(
      (attr) => attr.attribute_name === attributeName
    );
    const selectedOrder = selectedAttr?.attribute_order;

    const sameOrderAttrs = attributesObj.filter(
      (attr) => attr.attribute_order === selectedOrder
    );

    const isGrouped = sameOrderAttrs.length > 1;

    if (!attributeName) return null;
    const firstChar = attributeName.charAt(0);
    const rest = attributeName.slice(1);

    return (
      <span>
        <span style={{ color: isGrouped ? "red" : "inherit" }}>
          {firstChar}
        </span>
        {rest}
      </span>
    );
  };

  const handleSearchTerm = (event) => {
    event.preventDefault();
    // setSearchTerm(event?.target?.value)
    const value = nouns.filter((option) =>
      option.toLowerCase().includes(event?.target?.value.toLowerCase())
    );
    setOptionToShow(value.slice(0, 100));
  };

  const handleChange = (event, attribute, value) => {
    handleAttributeChange(attribute, value, "select");
  };

  return (
    <>
      <Paper
        sx={{
          width: "100%",
          margin: "20px 0px",
          borderRadius: "18px",
          paddingBottom: "10px",
        }}
        elevation={2}
      >
        {fetching ? (
          <>
            <Typography
              sx={{
                height: "70px",
                fontSize: "18px",
                padding: "20px",
              }}
            >
              Loading...
            </Typography>
          </>
        ) : (
          <>
            <div style={{ margin: "40px" }}>
              <Typography
                sx={{
                  fontFamily: "Verdana",
                  fontSize: "24px",
                  fontWeight: 400,
                  paddingTop: "20px",
                }}
              >
                Material Basic Data
              </Typography>
              <div className="partDesc" style={{ paddingBottom: "20px" }}>
                <div style={inputStyle} className="selectComponent">
                  <Typography style={headingStyle}>
                    Noun{" "}
                    <span
                      style={{
                        color: "#C6003D",
                        margin: "4px",
                        fontSize: "14px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Autocomplete
                    popupIcon={
                      <DropdownIcon
                        style={{
                          width: "20px",
                          position: "relative",
                          left: "0px",
                        }}
                      />
                    }
                    id="combo-box-demo"
                    options={nouns}
                    disableClearable={true}
                    value={noun}
                    onChange={(e, value) => {
                      handleNounChange(value);
                      setAttributeValue({});
                      setModifier("");
                    }}
                    renderInput={(params) => (
                      <TextField
                        className="formControlSelect"
                        placeholder="Select Noun"
                        {...params}
                        variant="outlined"
                      />
                    )}
                  />
                </div>
                <div style={inputStyle} className="selectComponent">
                  <Typography style={headingStyle}>
                    Modifier{" "}
                    <span
                      style={{
                        color: "#C6003D",
                        margin: "4px",
                        fontSize: "14px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Autocomplete
                    popupIcon={
                      <DropdownIcon
                        style={{
                          width: "20px",
                          position: "relative",
                          left: "0px",
                        }}
                      />
                    }
                    id="combo-box-demo"
                    options={modifiers}
                    disableClearable={true}
                    value={modifier}
                    onChange={(e, value) => {
                      handleModifierChange(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        className="formControlSelect"
                        placeholder="Select Modifier"
                        {...params}
                        variant="outlined"
                      />
                    )}
                  />
                </div>

                <div style={inputStyle} className="selectComponent">
                  <Typography style={headingStyle}>
                    Material Group{" "}
                    <span
                      style={{
                        color: "#C6003D",
                        margin: "4px",
                        fontSize: "14px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Autocomplete
                    popupIcon={
                      <DropdownIcon
                        style={{
                          width: "20px",
                          position: "relative",
                          left: "0px",
                        }}
                      />
                    }
                    id="combo-box-demo"
                    options={materialgroups}
                    disableClearable={true}
                    value={materialgroup}
                    getOptionLabel={(option) =>
                      option.material_group_description
                    }
                    onChange={(e, value) => {
                      setMaterialgroup(value);

                      setPartDescriptionData((prevValue) => ({
                        ...prevValue,
                        material_group: value?.material_group || "", // get value from selected object
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        className="formControlSelect"
                        placeholder="Select Material Group"
                        {...params}
                        variant="outlined"
                      />
                    )}
                  />
                </div>
                <div>
                  <Typography style={headingStyle}>
                    Material Group Number
                  </Typography>
                  <TextField
                    variant="outlined"
                    value={materialgroup?.material_group || ""}
                    // onChange={handleLeadTimeChange}
                    disabled
                    InputProps={{
                      sx: {
                        height: "32px",
                        borderRadius: "8px",
                        backgroundColor: "#f0f0f0", // Set the background color
                        color: "#000", // Set the text color
                        cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                        "&:hover": {
                          backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                        },
                        width: "fit-content",
                        paddingRight: "8px",
                      },
                    }}
                    fullWidth
                  />
                </div>
              </div>

              {noun && (
                <div>
                  <Divider />
                  <div style={inputStyle}>
                    <Typography style={headingStyle}>Description</Typography>
                    <Typography
                      style={{
                        fontFamily: "Verdana",
                        margin: "10px 0px 10px 0px",
                      }}
                    >
                      Short Description
                    </Typography>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        border: "1px solid #BDBDBD",
                        borderRadius: "4px",
                        padding: "10px",
                      }}
                    >
                      <Typography className="shortDesc">
                        {handlechipsValues()}
                      </Typography>
                    </div>

                    {modifier && materialgroup && (
                      <>
                        {loading && <p>Loading...</p>}
                        {!loading && (
                          <>
                            <Typography
                              style={{
                                fontFamily: "Verdana",
                                margin: "10px 0px 10px 0px",
                              }}
                            >
                              Data Attributes
                            </Typography>
                            <div
                              style={{
                                // display: "flex",
                                // flexWrap: "wrap",
                                border: "1px solid #BDBDBD",
                                borderRadius: "4px",
                                padding: "20px",
                              }}
                            >
                              {modifier !== "ANY" && (
                                <Typography
                                  style={{
                                    marginBottom: "10px",
                                    fontFamily: "Verdana",
                                    background: "#EFEFEF",
                                    padding: "10px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    width: "fit-content",
                                  }}
                                >
                                  {noun} {modifier}
                                </Typography>
                              )}

                              {modifier === "ANY" && (
                                <Typography
                                  style={{
                                    marginBottom: "10px",
                                    fontFamily: "Verdana",
                                    background: "#EFEFEF",
                                    padding: "10px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    width: "fit-content",
                                  }}
                                >
                                  {noun}
                                </Typography>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  flexWrap: "wrap",
                                }}
                              >
                                {attributes.map((attribute) => (
                                  <div
                                    key={attribute}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "baseline",
                                      width: "48%",
                                      margin: "0px 10px",
                                    }}
                                  >
                                    <Typography
                                      style={headingStyleAttribute}
                                      sx={{ width: "250px" }}
                                    >
                                      {renderStyledAttribute(attribute)}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        margin:
                                          uomValues[attribute].length > 0
                                            ? "0px 0px 0px 0px "
                                            : null,
                                      }}
                                    >
                                      :-
                                    </Typography>
                                    {typeAttributeValue[attribute] ===
                                    "string" ? (
                                      <>
                                        <div style={{ position: "relative" }}>
                                          <>
                                            <Autocomplete
                                              sx={{
                                                height: "32px",
                                                borderRadius: "4px",
                                                width:
                                                  uomValues[attribute].length >
                                                  0
                                                    ? "120px"
                                                    : "200px",
                                                background: "#FFFFFF",
                                                left:
                                                  uomValues[attribute].length >
                                                  0
                                                    ? "25px"
                                                    : "0px",
                                                margin:
                                                  uomValues[attribute].length >
                                                  0
                                                    ? "10px 0px 10px 22px"
                                                    : "10px 30px",
                                              }}
                                              popupIcon={
                                                <DropdownIcon
                                                  style={{
                                                    width: "20px",
                                                    position: "relative",
                                                    left: "0px",
                                                  }}
                                                />
                                              }
                                              id="combo-box-demo-sap"
                                              value={
                                                attributeValue[attribute] || ""
                                              }
                                              onChange={(e, value) => {
                                                handleChange(
                                                  e,
                                                  attribute,
                                                  value
                                                );
                                              }}
                                              options={
                                                attributeValues[attribute] || []
                                              }
                                              disableClearable={
                                                attributeValue[attribute]
                                                  ? false
                                                  : true
                                              } // Enable clear functionality
                                              renderInput={(params) => (
                                                <TextField
                                                  className="formControlSelect"
                                                  placeholder="Select Value"
                                                  {...params}
                                                  variant="outlined"
                                                />
                                              )}
                                              clearIcon={
                                                <ClearIcon
                                                  style={{
                                                    position: "relative",
                                                    top: "0px",
                                                    height: "18px",
                                                    width: "18px",
                                                  }}
                                                />
                                              }
                                            />
                                          </>
                                        </div>
                                      </>
                                    ) : (
                                      /* Remaining type of data */
                                      <>
                                        <div style={{ position: "relative" }}>
                                          <input
                                            placeholder="Enter Value"
                                            name={attribute}
                                            type="text"
                                            // Update the pattern to accept only digits, commas, slashes, dots, and hyphens
                                            pattern="[0-9,/.\\-\s]*"
                                            inputmode="numeric"
                                            className="uomInputValue"
                                            autoComplete="off"
                                            onChange={(event) => {
                                              handleAttributeChange(
                                                attribute,
                                                event.target.value,
                                                "nonSelect"
                                              );
                                            }}
                                            value={
                                              attributeTypeValue[attribute] ||
                                              ""
                                            }
                                            style={{
                                              // left:
                                              //   uomValues[attribute].length > 0
                                              //     ? "10px"
                                              //     : "0px",
                                              // margin:
                                              //   uomValues[attribute].length > 0
                                              //     ? "10px 0px 10px 22px "
                                              //     : "10px 30px",
                                              borderRadius: "4px",
                                              padding: "6px 10px",
                                              margin: "10px 110px 10px 32px",
                                              height: "32px",
                                              width: "120px",
                                              position: "relative",
                                              top: "-2px",
                                              outlineStyle: "none",
                                              border: "1px solid #cbc3c3",
                                            }}
                                          />
                                          {uomValues[attribute].length > 0 && (
                                            <>
                                              <div>
                                                <Typography
                                                  style={{
                                                    fontFamily: "Verdana",
                                                    // background: "#EFEFEF",
                                                    fontSize: "13px",
                                                    position: "absolute",
                                                    top: "-16px",
                                                    right: "60px",
                                                    fontWeight: "560",
                                                  }}
                                                >
                                                  UOM{" "}
                                                  {attributeTypeValue[
                                                    attribute
                                                  ] && (
                                                    <span
                                                      style={{
                                                        color: "#C6003D",
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Typography>
                                                <Select
                                                  displayEmpty
                                                  sx={{
                                                    height: "32px",
                                                    borderRadius: "4px",
                                                    width: "80.2px",
                                                    background: "#FFFFFF",
                                                    margin: "10px 0px",
                                                    position: "absolute",
                                                    right: "28px",
                                                    top: "-2px",
                                                  }}
                                                  //

                                                  value={
                                                    uomValue[attribute] || ""
                                                  }
                                                  onChange={(event) =>
                                                    handleAttributeChange(
                                                      attribute,
                                                      event.target.value,
                                                      "UOMChange"
                                                    )
                                                  }
                                                  inputProps={{
                                                    "aria-label":
                                                      "Without label",
                                                  }}
                                                  input={<OutlinedInput />}
                                                  IconComponent={({
                                                    className,
                                                  }) => (
                                                    <DropdownIcon
                                                      className={className}
                                                      style={{
                                                        width: "20px",
                                                        height: "09px",
                                                        position: "absolute",
                                                        top: "50%",
                                                        right: "10px",
                                                        transform:
                                                          "translateY(-50%)", // Ensures vertical centering
                                                      }}
                                                    />
                                                  )}
                                                  MenuProps={uomProps}
                                                  disabled={
                                                    !attributeTypeValue[
                                                      attribute
                                                    ]
                                                  }
                                                >
                                                  <MenuItem disabled value="">
                                                    <span
                                                      style={{
                                                        color: "#333333",
                                                      }}
                                                    >
                                                      Select
                                                    </span>
                                                  </MenuItem>
                                                  {uomValues[attribute]?.map(
                                                    (value) => (
                                                      <MenuItem
                                                        key={value}
                                                        value={value}
                                                      >
                                                        {value}
                                                      </MenuItem>
                                                    )
                                                  )}
                                                </Select>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </>
                                    )}
                                    {/* {uomValues[attribute].length > 0 && (
                                      <Select
                                        displayEmpty
                                        sx={{
                                          height: "32px",
                                          borderRadius: "4px",
                                          width: "80px",
                                          background: "#FFFFFF",
                                          margin: "10px 0px",
                                          right: "25px"
                                        }}
                                        value={uomValue[attribute] || ""}
                                        onChange={(event) =>
                                          handleUomChange(
                                            attribute,
                                            event.target.value
                                          )
                                        }
                                        inputProps={{ "aria-label": "Without label" }}
                                        input={<OutlinedInput />}
                                        IconComponent={() => <DropdownIcon style={{ width: "20px", position: "relative", left: "-10px" }} />}
                                        MenuProps={uomProps}
                                      >
                                        <MenuItem disabled value="">
                                          <span style={{ color: "#333333" }}>
                                            Select
                                          </span>
                                        </MenuItem>
                                        {uomValues[attribute]?.map((value) => (
                                          <MenuItem key={value} value={value}>
                                            {value}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    )} */}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
              <div style={{ margin: "25px 0px" }}>
                <button
                  type="submit"
                  className="submitButton"
                  style={{
                    fontSize: 16,
                    cursor: "pointer",
                    // position: "relative",
                    fontFamily: "Verdana",
                    margin: "0px",
                    background:
                      Object.keys(attributeValue).length > 0 &&
                      Object.keys(uomValue).length === totalUomValues
                        ? "#C6003D"
                        : "#f5f5f5",
                    cursor:
                      Object.keys(attributeValue).length > 0 &&
                      Object.keys(uomValue).length === totalUomValues
                        ? "pointer"
                        : "default",
                    color:
                      Object.keys(attributeValue).length > 0 &&
                      Object.keys(uomValue).length === totalUomValues
                        ? "#FFFFFF"
                        : "#C6003D",
                  }}
                  onClick={(e) => {
                    handleNext();
                  }}
                  disabled={
                    Object.keys(attributeValue).length > 0 &&
                    Object.keys(uomValue).length === totalUomValues
                      ? false
                      : true
                  }
                >
                  Next
                </button>
                <button
                  type="submit"
                  className="cancelButton"
                  style={{
                    fontSize: 16,
                    cursor: "pointer",
                    position: "relative",
                    fontFamily: "Verdana",
                  }}
                  onClick={(e) => {
                    handleReset();
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </>
        )}
      </Paper>
    </>
  );
};

export default PartDescription;
